import { MDBBtn, MDBIcon } from 'mdb-react-ui-kit';
import React from 'react'
import ScrollTo from "react-scroll-into-view";


const NavigationButton = ({mySelector, myIcon, hasMargin}) => {
  return (
    <ScrollTo selector={mySelector}>
        <MDBBtn floating size='lg' className="p-3 m-2 d-none d-md-flex justify-content-center align-items-center section-btn" >
            <MDBIcon fas icon={myIcon} size='2x' className={`icon-navigation ${hasMargin ? 'mt-1' : ''}`}/>
        </MDBBtn>
    </ScrollTo>
  )
}

export default NavigationButton